import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import IEInfo from './pages/IEInfo/IEInfo.vue'
import Accueil from './pages/Accueil/Accueil.vue'
import MentionsLegales from './pages/MentionsLegales/MentionsLegales.vue'
import FAQ from './pages/FAQ/FAQ.vue'
import Watch from './pages/Watch/Watch.vue'
import CvaPresentation from './pages/CvaPresentation/CvaPresentation.vue'
import AssistanceAssurances from './pages/AssistanceAssurances/AssistanceAssurances.vue'
import PaiementsInternet from './pages/PaiementsInternet/PaiementsInternet.vue'
import DataProtection from './pages/DataProtection/DataProtection.vue'
import Messagerie from './pages/Messagerie/Messagerie.vue'
import HowToMessagerie from './pages/Messagerie/HowToMessagerie.vue'
import Documentation from './pages/Documentation/Documentation.vue'
import RechercheEntreprise from './pages/Administration/RechercheEntreprise/RechercheEntreprise.vue'
import UserLocked from './pages/Administration/User/UserLocked.vue'
import UserAdminLocked from './pages/Administration/User/UserAdminLocked.vue'
import UserList from './pages/Administration/User/UserList.vue'
import RoleList from './pages/Administration/Role/RoleList.vue'
import RoleCreate from './pages/Administration/Role/RoleCreate.vue'
import RoleView from './pages/Administration/Role/RoleView.vue'
import PeriodeList from './pages/Administration/Periode/PeriodeList.vue'
import PeriodeView from './pages/Administration/Periode/PeriodeView.vue'
import PeriodeCreate from './pages/Administration/Periode/PeriodeCreate.vue'
import PeriodeEdit from './pages/Administration/Periode/PeriodeEdit.vue'
import Logs from './pages/Administration/Logs/Logs.vue'
import BatchLogs from './pages/Administration/BatchLogs/BatchLogs.vue'
import GestionnaireDepenses from './pages/Entreprise/GestionnaireDepenses/GestionnaireDepenses.vue'
import GestionnaireOperations from './pages/Entreprise/GestionnaireOperations/GestionnaireOperations.vue'
import GestionnaireRapport from './pages/Entreprise/GestionnaireRapport/GestionnaireRapport.vue'
import GestionnaireTelechargement from './pages/Entreprise/GestionnaireTelechargement/GestionnaireTelechargement.vue'
import GestionnaireParcDeCarte from './pages/Entreprise/GestionnaireParcDeCarte/GestionnaireParcDeCarte.vue'
import GestionnaireParcDeCarteDetail from './pages/Entreprise/GestionnaireParcDeCarte/GestionnaireParcDeCarteDetail.vue'
import GestionnaireRelevesPorteur from './pages/Entreprise/GestionnaireRelevesPorteur/GestionnaireRelevesPorteur.vue'
import RechercheOperation from './pages/Administration/RechercheOperation/RechercheOperation.vue'
import MajMail from './pages/Administration/MajMail/MajMail.vue'
import UserView from './pages/Administration/User/UserView.vue'
import UserEdit from './pages/Administration/User/UserEdit.vue'
import UserCreate from './pages/Administration/User/UserCreate.vue'
import DepensesCartes from './pages/Porteur/DepensesCartes/DepensesCartes.vue'
import DetailCarte from './pages/Porteur/DetailCarte/DetailCarte.vue'
import CoordonneesPorteur from './pages/Porteur/Coordonnees/CoordonneesPorteur.vue'
import OperationsCarte from './pages/Porteur/OperationsCarte/OperationsCarte.vue'
import ReleveOperations from './pages/Porteur/ReleveOperations/ReleveOperations.vue'
import ForgotCredentials from './pages/Credentials/ForgotCredentials.vue'
import ForgotLogin from './pages/Credentials/ForgotLogin.vue'
import ForgotPassword from './pages/Credentials/ForgotPassword.vue'
import ChangePassword from './pages/Credentials/ChangePassword.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/IEInfo',
      name: 'IEInfo',
      meta: {
        auth: false
      },
      component: IEInfo
    },
    {
      path: '/accueil',
      name: 'accueil',
      meta: {
        auth: false
      },
      component: Accueil
    },
    {
      path: '/mentionslegales',
      name: 'mentionslegales',
      meta: {
        auth: false
      },
      component: MentionsLegales
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      meta: {
        auth: false
      },
      component: FAQ
    },
    {
      path: '/cvapresentation',
      name: 'cvapresentation',
      meta: {
        auth: false
      },
      component: CvaPresentation
    },
    {
      path: '/assistanceassurances',
      name: 'assistanceassurances',
      meta: {
        auth: false
      },
      component: AssistanceAssurances
    },
    {
      path: '/paiementsinternet',
      name: 'paiementsinternet',
      meta: {
        auth: false
      },
      component: PaiementsInternet
    },
    {
      path: '/dataprotection',
      name: 'dataprotection',
      meta: {
        auth: false
      },
      component: DataProtection
    },
    {
      path: '/messagerie',
      name: 'messagerie',
      meta: {
        auth: true
      },
      component: Messagerie
    },
    {
      path: '/howtomessagerie',
      name: 'howtomessagerie',
      meta: {
        auth: true
      },
      component: HowToMessagerie
    },
    {
      path: '/documentation',
      name: 'documentation',
      meta: {
        auth: true
      },
      component: Documentation
    },
    {
      path: '/administration/adminrechercheentreprise',
      name: 'administration/adminrechercheentreprise',
      meta: {
        auth: true
      },
      component: RechercheEntreprise
    },
    {
      path: '/administration/user/listlocked',
      name: 'administration/user/listlocked',
      meta: {
        auth: true
      },
      component: UserLocked
    },
    {
      path: '/administration/user/listlockedadmin',
      name: 'administration/user/listlockedadmin',
      meta: {
        auth: true
      },
      component: UserAdminLocked
    },
    {
      path: '/administration/user/list',
      name: 'administration/user/list',
      meta: {
        auth: true
      },
      component: UserList
    },
    {
      path: '/administration/role/list',
      name: 'administration/role/list',
      meta: {
        auth: true
      },
      component: RoleList
    },
    {
      path: '/administration/role/create',
      name: 'administration/role/create',
      meta: {
        auth: true
      },
      component: RoleCreate
    },
    {
      path: '/administration/role/view',
      name: 'administration/role/view',
      meta: {
        auth: true
      },
      props: true,
      component: RoleView
    },
    {
      path: '/administration/periode/list',
      name: 'administration/periode/list',
      meta: {
        auth: true
      },
      component: PeriodeList
    },
    {
      path: '/administration/periode/view',
      name: 'administration/periode/view',
      meta: {
        auth: true
      },
      props: true,
      component: PeriodeView
    },
    {
      path: '/administration/periode/create',
      name: 'administration/periode/create',
      meta: {
        auth: true
      },
      component: PeriodeCreate
    },
    {
      path: '/administration/periode/edit',
      name: 'administration/periode/edit',
      meta: {
        auth: true
      },
      props: true,
      component: PeriodeEdit
    },
    {
      path: '/administration/adminlogs',
      name: 'administration/adminlogs',
      meta: {
        auth: true
      },
      component: Logs
    },
    {
      path: '/administration/batchlogs',
      name: 'administration/batchlogs',
      meta: {
        auth: true
      },
      component: BatchLogs
    },
    {
      path: '/administration/adminrechercheoperations',
      name: 'administration/adminrechercheoperations',
      meta: {
        auth: true
      },
      component: RechercheOperation
    },
    {
      path: '/entreprise/gestionnairedepenses',
      name: 'entreprise/gestionnairedepenses',
      meta: {
        auth: true
      },
      component: GestionnaireDepenses
    },
    {
      path: '/entreprise/gestionnaireoperations',
      name: 'entreprise/gestionnaireoperations',
      meta: {
        auth: true
      },
      component: GestionnaireOperations
    },
    {
      path: '/entreprise/gestionnairerapport',
      name: 'entreprise/gestionnairerapportentreprise',
      meta: {
        auth: true
      },
      component: GestionnaireRapport
    },
    {
      path: '/entreprise/gestionnairetelechargement',
      name: 'entreprise/gestionnairetelechargement',
      meta: {
        auth: true
      },
      component: GestionnaireTelechargement
    },
    {
      path: '/entreprise/gestionnaireparcdecartes',
      name: 'entreprise/gestionnaireparcdecartes',
      meta: {
        auth: true
      },
      component: GestionnaireParcDeCarte
    },
    {
      path: '/entreprise/gestionnaireparcdecartesdetail',
      name: 'entreprise/gestionnaireparcdecartesdetail',
      meta: {
        auth: true
      },
      props: true,
      component: GestionnaireParcDeCarteDetail
    },
    {
      path: '/entreprise/gestionnairerelevesporteurs',
      name: 'entreprise/gestionnairerelevesporteurs',
      meta: {
        auth: true
      },
      component: GestionnaireRelevesPorteur
    },
    {
      path: '/administration/adminmajadressemail',
      name: 'administration/adminmajadressemail',
      meta: {
        auth: true
      },
      component: MajMail
    },
    {
      path: '/administration/user/view',
      name: 'administration/user/view',
      meta: {
        auth: true
      },
      component: UserView,
      props: true
    },
    {
      path: '/administration/user/edit',
      name: 'administration/user/edit',
      meta: {
        auth: true
      },
      component: UserEdit,
      props: true
    },
    {
      path: '/administration/user/create',
      name: 'administration/user/create',
      meta: {
        auth: true
      },
      component: UserCreate
    },
    {
      path: '/porteur/depensescarte',
      name: 'porteur/depensescarte',
      meta: {
        auth: true
      },
      component: DepensesCartes
    },
    {
      path: '/porteur/detailcarte',
      name: 'porteur/detailcarte',
      meta: {
        auth: true
      },
      component: DetailCarte
    },
    {
      path: '/porteur/releveoperation',
      name: 'porteur/releveoperation',
      meta: {
        auth: true
      },
      component: ReleveOperations
    },
    {
      path: '/porteur/coordonnee',
      name: 'porteur/coordonnee',
      meta: {
        auth: true
      },
      component: CoordonneesPorteur
    },
    {
      path: '/porteur/operationscarte',
      name: 'porteur/operationscarte',
      meta: {
        auth: true
      },
      component: OperationsCarte
    },
    {
      path: '/watch',
      name: 'watch',
      meta: {
        auth: false
      },
      component: Watch
    },
    {
      path: '/oublicodeacces',
      name: 'oublicodeacces',
      meta: {
        auth: false
      },
      component: ForgotCredentials
    },
    {
      path: '/oubliidentifiant',
      name: 'oubliidentifiant',
      meta: {
        auth: false
      },
      component: ForgotLogin
    },
    {
      path: '/oublipassword',
      name: 'oublipassword',
      meta: {
        auth: false
      },
      component: ForgotPassword
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      meta: {
        auth: false
      },
      props: true,
      component: ChangePassword
    },
    {
      path: '/*',
      redirect: '/accueil'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isIE = !!document.documentMode
  if (isIE && to.name !== 'IEInfo') {
    next({ path: '/IEInfo' })
  } else {
    if (to.name === 'login' && store.state.user.status.loggedIn) {
      next({ path: '/accueil' })
    } else {
      next()
    }

    if (to.meta.auth && !store.state.user.status.loggedIn) {
      // Si on ferme l'onglet et qu'on revient sur le site :
      // --> On check si le cookie est valide pour remonter la connexion, sinon on logout
      store.dispatch('user/relogUserIfNecessary').then(
        response => {
          // On reload la page pour tout charger correctement
          location.reload()
        },
        () => {
          next({ path: '/accueil' })
        }
      )
    } else {
      next()
    }

    // Au cas ou une injection est tentée, on retire les query de la route car on ne s'en sert pas dans la site
    if (Object.keys(to.query).length) {
      next({ path: to.path })
    } else {
      next()
    }
    next()
  }
})

export default router
